<template>
  <div class="hello">
    <h2>Dual Smart Card</h2>
    <h2>User Manual</h2>
    <img src="../../assets/crd.jpg" alt="Wireless Tag Logo" class="logo" />
    
       <!-- 新增的三个竖排按钮 -->
    <div class="button-container">
        <router-link to="/card/dual/android">
      <van-button  type="default" block class="custom-button">
        <img src="../../assets/google_hub.png" alt="Google Find My Device" class="button-icon" />
        For Android (Google Find Hub)
      </van-button>
      </router-link>
      
    <router-link to="/card/dual/ios">
      <van-button  type="default" block class="custom-button">
        <img src="../../assets/find_my.png" alt="Apple Find My" class="button-icon" />
        For IOS (Apple Find My)
      </van-button>
    </router-link>
  
     
    </div>

  </div>
</template>


<script>
import { Button } from 'vant';
export default {
  name: 'DualCard',
  props: {
    msg: String
  },
  components: {
    [Button.name]: Button,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.button-container {
  display: flex;
  flex-direction: column;
  gap: 20px; /* 按钮之间的垂直间距 */
  margin: 30px; /* 设置左边距 */

}
.hello { 
  border-radius: 16px; /* 圆角 */
  margin: 20px; /* 可选：外边距 */
  overflow: hidden; /* 防止子元素超出圆角边界 */
  width: 90%;
  height: 90%;
}
.logo {
  width: 100px; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}
.android {
  width: 250px; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}
.button-icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 8px;
  object-fit: contain;
}
.custom-button {
  background-color: transparent !important;
  border: 2px solid #4285F4 !important;
  color: #333 !important;
}
.custom-button:hover {
  background-color: #f5f5f5 !important;
  border-color: #4285F4 !important;
}
</style>